// extracted by mini-css-extract-plugin
export default {"added":"JQnHj","iconCheck":"ULeY2","text":"fTaXK"};